
import { useOutletContext } from "react-router-dom";
import { ConfigContext } from '../../ConfigContext';
import { useContext } from 'react';

export default function LandingPage() {
    
    const { dynamicConfig } = useOutletContext();
    const { bootstrapConfig } = useContext(ConfigContext);

    return (
        <div id="landing-page">
            <h1>Welcome to the Moogy's Website!</h1>
            <p>dynamic config fetched at each route change:<pre>{dynamicConfig && JSON.stringify(dynamicConfig)}</pre></p>
            <p>dynamic config fetched once for the root context:<pre>{bootstrapConfig && JSON.stringify(bootstrapConfig)}</pre></p>
        </div>
    )
}